import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  UserContext,
  UserContextProvider,
} from "../components/users/UserContext";
import { useContext } from "react";
import Logo from "../components/mainPage/Logo";

const AccountInfo = () => {
  const ACCOUNT_URL = process.env.REACT_APP_ARI_URL + "/account";

  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const userToken = JSON.parse(token);
  let bearer = "Bearer " + userToken;
  const user = useContext(UserContext);

  const TIMEOUT_SCENARIOS_RELOAD = 500;
  const [isTimeToShow, setIsTimeToShow] = useState(false);

  useEffect(() => {
    const timeoutID = window.setTimeout(() => {
      setIsTimeToShow(true);
    }, TIMEOUT_SCENARIOS_RELOAD);
    return () => window.clearTimeout(timeoutID);
  }, []);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await fetch(`${ACCOUNT_URL}`, {
          headers: {
            Authorization: bearer,
          },
        });
        if (response.status === 401) {
          navigate("/login");
        }
        const data = await response.json();
        setItems(data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchItems();
  }, []);

  const AccountData = Object.entries(items).map(([key, val], i) => (
    <tr key={i}>
      <td>{key}</td>
      <td>{val}</td>
    </tr>
  ));

  return (
    <>
      {isTimeToShow && (
        <div className="main-page-graphAndTree">
          <div className="item tree">
            <div className="logo-background">
              <Logo />
            </div>
            <div className="folders-panel"></div>
            <div className="left-link-space">
              <Link to="/logout">
                <button className="small-button red">LOGOUT</button>
              </Link>
              {user?.role === "ADMIN" && (
                <Link to="/users">
                  <button className="small-button deep-blue">USERS</button>
                </Link>
              )}
              <Link to="/">
                <button className="small-button deep-blue">SCENARIOS</button>
              </Link>
            </div>
            <div className="item graph">
              <div className="users">
                <h4> ACCOUNT INFO </h4>
                <table className="table table-hover table-responsive">
                  <thead>
                    <tr>
                      <th>KEY</th>
                      <th>VALUE</th>
                    </tr>
                  </thead>
                  <tbody>{AccountData}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AccountInfo;
